import DetailView from "./DetailView";

export default DetailView;
